export enum EZIndexes {
  Z_2 = 'z-[2]',
  AUTH_BACKGROUND = 'z-[5]',

  USER_TASK_HISTORY_BUTTON_SHOW_CONTENT = 'z-[10]',
  SLIDER_RANGE_DRAG_CONTROL = 'z-[10]',
  AUTH_MAIN = 'z-[10]',
  AUTH_BUTTON_HELP = 'z-[10]',
  IMAGE_CANVAS_DRAG_AND_DROP = 'z-[10]',

  SLIDER_THUMBS = 'z-[20]',
  MOBILE_SIDEBAR_NAVIGATION = 'z-[20]',
  BUTTON_CHANGE_LANGUAGE = 'z-[20]',

  IMAGE_CANVAS_DRAG_AND_DROP_WRAPPER = 'z-[50]',

  FULLSCREEN_VIEW = 'z-[60]',

  FULLSCREEN_VIEW_IMAGE = 'z-[61]',
  TOAST = 'z-[61]',

  DROPDOWN_MENU = 'z-[70]',

  TOOLTIP = 'z-[71]',

  DRAG_AND_DROP_OVERLAY = 'z-[500]',

  SPLASH_SCREEN_LOADING = 'z-[1000]',
}
